module.exports = __webpack_public_path__ + "assets/media/DEFAULT_PROFILE_IMAGE.709bcb40.svg";